module.exports = __webpack_public_path__ + "img/start_academy_hwfy.192209b8.jpg";